import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './route/AppRouter';

// paleta de cores https://color.adobe.com/pt/search?q=purple&t=term

ReactDOM.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
  document.getElementById('root')
);

